<template>
  <div>
    <component
      :is="s.slice_type"
      v-for="(s, idx) in slices"
      :key="idx"
      :slice="s.slice_type === 'phone_carousel' ? selectedContent : s"
      :selected-option="s.slice_type === 'options' ? selectedOption : undefined"
      @onSelect="onSelect"
    />
  </div>
</template>

<script>
import { Hero, LogoBanner, SimpleCta, CustomerService, RefundSchema, TrustpilotCarousel, PhoneCarousel } from '@@/shared-slices'

import { Options, AppBlock } from './components'

export default {
  name: 'RefundsModule',
  components: {
    hero: Hero,
    logo_banner: LogoBanner,
    options: Options,
    phone_carousel: PhoneCarousel,
    app_block: AppBlock,
    simple_cta: SimpleCta,
    customer_service: CustomerService,
    refund_schema: RefundSchema,
    trustpilot_carousel: TrustpilotCarousel,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    const variation = this.data.body.find((s) => s.slice_type === 'phone_carousel').variation

    return {
      selectedOption: this.getInitialOptionIndex(),
      optionContents: this.data.body.filter((s) => s.slice_type === 'option_content').map((s) => ((s.variation = variation), s)),
      slices: this.data.body.filter((s) => s.slice_type !== 'option_content'),
    }
  },

  computed: {
    selectedContent() {
      return this.optionContents.find((s) => s.primary.index === this.selectedOption)
    },
  },

  methods: {
    getInitialOptionIndex() {
      const optionSlice = this.data.body.find((s) => s.slice_type === 'options')
      return optionSlice ? optionSlice.primary.initial_index : 0
    },

    onSelect(index) {
      this.selectedOption = index
    },
  },
}
</script>
